/**
 * Count & Entry API Client
 * REST endpoints for manual count entries and aggregated count views.
 * Counts fall back to fixture data when the API is unavailable; entries do not.
 */

import apiClient from './api';
import { getCounts } from '../fixtures/seedData';

// Counts
export const fetchProjectCounts = async (projectId) => {
  try {
    return await apiClient.get(`/projects/${projectId}/counts`);
  } catch {
    console.warn('[FIXTURE] fetchProjectCounts fallback for', projectId);
    return getCounts(projectId);
  }
};

export const fetchViewportCounts = async (projectId, bounds) => {
  try {
    return await apiClient.get(`/projects/${projectId}/counts/viewport?north=${bounds.north}&south=${bounds.south}&east=${bounds.east}&west=${bounds.west}`);
  } catch {
    console.warn('[FIXTURE] fetchViewportCounts fallback for', projectId);
    return getCounts(projectId);
  }
};

export const fetchScopeCounts = async (projectId, scopeId) => {
  try {
    return await apiClient.get(`/projects/${projectId}/scopes/${scopeId}/counts`);
  } catch {
    console.warn('[FIXTURE] fetchScopeCounts fallback for', projectId, scopeId);
    const result = getCounts(projectId);
    return { items: (result.items || []).filter((c) => c.scopeId === scopeId) };
  }
};

// Entries (ASS-64). No fallback: the real endpoints are live, and a silent
// local fallback would let a failed save look like a successful one. Errors
// propagate to countSlice, which surfaces them in the UI.
export const submitEntry = (projectId, data) =>
  apiClient.post(`/projects/${projectId}/entries`, data);

export const fetchEntries = (projectId, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.scopeId) params.set('scopeId', filters.scopeId);
  if (filters.locationId) params.set('locationId', filters.locationId);
  if (filters.channel) params.set('channel', filters.channel);
  if (filters.userId) params.set('userId', filters.userId);
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  if (filters.limit) params.set('limit', filters.limit);
  if (filters.nextToken) params.set('nextToken', filters.nextToken);
  const qs = params.toString();
  return apiClient.get(`/projects/${projectId}/entries${qs ? `?${qs}` : ''}`);
};

export const fetchEntry = async (entryId) => {
  try {
    return await apiClient.get(`/entries/${entryId}`);
  } catch {
    console.warn('[FIXTURE] fetchEntry fallback — not available');
    return { item: null };
  }
};
